import React from 'react';
import { Tooltip } from '@nextui-org/react';
import { QUARTILE_COLORS } from 'common/src/utils/definitions';

interface SettlementsLightsProps {
  nulls?: number;
  q1: number;
  q2: number;
  q3: number;
  q4: number;
  size?: 'sm' | 'md' | 'lg';
  comparablePercentage?: number;
  showGray?: boolean;
}

const SettlementsLights: React.FC<SettlementsLightsProps> = ({
  nulls = 0,
  q1,
  q2,
  q3,
  q4,
  size = 'sm',
  comparablePercentage,
  showGray = false,
}) => {
  const sizeClasses = {
    sm: 'w-2 h-[60%]',
    md: 'w-3 h-[70%]',
    lg: 'w-4 h-[80%]',
  };

  const textSizeClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-2xl',
  };

  return (
    <div className='flex flex-col items-center gap-2'>
      <div className='flex gap-2'>
        {showGray && (
          <Tooltip content='% no comparable'>
            <div className='flex items-center gap-2'>
              <div
                className={`${sizeClasses[size]} ${QUARTILE_COLORS['0']} rounded`}
              ></div>
              <span className={`${textSizeClasses[size]} font-bold`}>{nulls}%</span>
            </div>
          </Tooltip>
        )}
        <Tooltip content='Q1'>
          <div className='flex items-center gap-2'>
            <div
              className={`${sizeClasses[size]} ${QUARTILE_COLORS['1']} rounded`}
            ></div>
            <span className={`${textSizeClasses[size]} font-bold`}>{q1}%</span>
          </div>
        </Tooltip>
        <Tooltip content='Q2'>
          <div className='flex items-center gap-2'>
            <div
              className={`${sizeClasses[size]} ${QUARTILE_COLORS['2']} rounded`}
            ></div>
            <span className={`${textSizeClasses[size]} font-bold`}>{q2}%</span>
          </div>
        </Tooltip>
        <Tooltip content='Q3'>
          <div className='flex items-center gap-2'>
            <div
              className={`${sizeClasses[size]} ${QUARTILE_COLORS['3']} rounded`}
            ></div>
            <span className={`${textSizeClasses[size]} font-bold`}>{q3}%</span>
          </div>
        </Tooltip>
        <Tooltip content='Q4'>
          <div className='flex items-center gap-2'>
            <div
              className={`${sizeClasses[size]} ${QUARTILE_COLORS['4']} rounded`}
            ></div>
            <span className={`${textSizeClasses[size]} font-bold`}>{q4}%</span>
          </div>
        </Tooltip>
      </div>
      {comparablePercentage !== undefined && (
        <div className="text-xs text-default-500">
          ({comparablePercentage.toFixed(1)}% comparable)
        </div>
      )}
    </div>
  );
};

export default SettlementsLights;
